/* eslint-disable indent */
import PercentageCircle from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import dateFormatter from "@/helperFuntions/dateFormater";
import useProjectQuery, { Project } from "../../api/query/useProjectQuery";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import CreateUpdateProjectForm from "@/components/project/CreateProjectForm";
import NoProject from "../../components/project/NoProject";
import Loader from "@/components/common/Loader";
import UserAvatar from "@/components/ui/userAvatar";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ScrollText, Settings } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import CreateProjectForm from "../../components/project/CreateProjectForm";
import {
  PlanTypeEnumSchema,
  ProjectDefaultViewEnumValue,
  ProjectStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import useProjectDuplicateMutation from "@/api/mutation/useDuplicateProject";
import { toast } from "react-toastify";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import Users from "@/assets/svg/Users.svg";
import { useUser } from "@/hooks/useUser";
import { errorConfig } from "@/lib/toastError";
import Dialog from "@/components/common/Dialog";
import useRemoveProjectMutation from "@/api/mutation/useProjectRemoveMutation";
import TrashCan from "@/assets/svg/TrashCan.svg";
import Plus from "@/assets/svg/NoramlPlus.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { usePlanValidation } from "@/hooks/usePlan";
import InputText from "@/components/common/InputText";
import usePortfolioUpdateMutation from "@/api/mutation/useUpdatePortfolioMutation";
import useProgramUpdateMutation from "@/api/mutation/useProgramUpdateMutaion";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import gantt from "@/assets/svg/ganttNew.svg";
import list from "@/assets/svg/listNew.svg";
import CheckedSvg from "@/assets/svg/checked.svg";
import GanttView from "./ganttView";
import NoFilterProject from "./noProject";
import ProjectFilter from "./projectFilter";
import { FIELDS } from "@/api/types/enums";
import dateFormater from "@/helperFuntions/dateFormater";
import Collaps from "@/assets/svg/collaps.svg";
import Expand from "@/assets/svg/expand.svg";
import ZoomOut from "@/assets/svg/ZoomOut.svg";
import ZoomIn from "@/assets/svg/ZoomIn.svg";
import FullScreen from "@/assets/svg/FullScreen.svg";
import ExitFullscreen from "@/assets/svg/ExitFullscreen.svg";
import Refresh from "@/assets/svg/Refresh.svg";
import * as XLSX from "xlsx";
import ExcelIcon from "@/assets/svg/Excel.svg";
import Select from "react-select";
import { Options } from "@/components/views/ganntView/GanttView";
import InfoCircle from "@/assets/svg/Info circle.svg";
import crossNew from "@/assets/svg/crossNew.svg";
import { OrgListOfNonWorkingDaysEnum } from "@backend/src/schemas/organisationSchema";
import calculatePortfolioAndProgramSPIs from "@/helperFuntions/projectherarch";

//================================================================
// 1. NEW HIERARCHY TYPE DEFINITIONS
//================================================================

// A project in the final hierarchy will always have these properties
export interface ProjectNode extends Project {
  type: "project";
  progress: number;
}

// A program in the final hierarchy
export interface ProgramNode {
  type: "program";
  programId: string;
  programName: string;
  progress: number;
  projects: ProjectNode[];
}

// A portfolio in the final hierarchy
export interface PortfolioNode {
  type: "portfolio";
  portfolioId: string;
  portfolioName: string;
  progress: number;
  projects: ProjectNode[]; // Projects directly under the portfolio
  programs: ProgramNode[];
}

// The final data structure for your state is a union of these types
export type HierarchyItem = PortfolioNode | ProgramNode | ProjectNode;

// Internal type used during calculation to hold temporary values
type Calculable<T> = T & {
  __totalDuration: number;
  __weightedProgress: number;
};
const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: "2px solid #299d91",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
};

//================================================================
// PROJECTS LIST COMPONENT
//================================================================

function ProjectsList() {
  const [data, setData] = useState<Project[]>();
  const [filterData, setFilterData] = useState<Project[]>();

  // State now uses the new, strongly-typed HierarchyItem
  const [hierarchyData, setHierarchyData] = useState<HierarchyItem[]>([]);

  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [editData, setEditData] = useState<Project | undefined>();
  const [projectId, setProjectId] = useState<string>();
  const { user } = useUser();
  const navigate = useNavigate();
  const projectQuery = useProjectQuery(true);
  const [searchParams] = useSearchParams();
  const [remove, setRemove] = useState<string>();
  const removeProjectMutation = useRemoveProjectMutation();
  const { t } = useTranslation();
  const viewOption = [
    {
      icon: gantt,
      value: ProjectDefaultViewEnumValue.GANTT,
    },
    {
      icon: list,
      value: ProjectDefaultViewEnumValue.LIST,
    },
  ];
  const [view, setView] = useState(viewOption[0].value);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    if (user && (!user.firstName || !user.lastName)) {
      navigate("/account-settings", { state: { edit: true } });
    }
  }, [user]);


  useEffect(() => {
       setLoader(true)
       setData(projectQuery.data?.data.data ??[]);
    setLoader(false)

  }, [projectQuery.data?.data.data]);

  //================================================================
  // 2. NEW HIERARCHY LOGIC IMPLEMENTATION
  //================================================================

  const nonWorkingDays = useCallback(() => {
    const nWd =
      user?.userOrganisation?.map((org) => org.organisation.nonWorkingDays) ||
      [];
    const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
      switch (day) {
        case "SUN":
          return 0;
        case "MON":
          return 1;
        case "TUE":
          return 2;
        case "WED":
          return 3;
        case "THU":
          return 4;
        case "FRI":
          return 5;
        case "SAT":
          return 6;
        default:
          return 0;
      }
    };
    const result: number[] = [];
    nWd.forEach((days) => {
      days.forEach((day) => {
        result.push(mapDayToNumber(day));
      });
    });
    return result;
  }, [user]);

  const UTCDateConverter = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    );
  };

  // Using your existing duration calculation for business logic consistency
  const calculateDurations = useCallback(
    (startDate: Date, endDate: Date): number => {
      const start = UTCDateConverter(new Date(startDate));
      const end = UTCDateConverter(new Date(endDate));

      end.setDate(end.getDate() + 1);
      const excludedDays = nonWorkingDays();
      const holidays =
        user?.userOrganisation?.[0]?.organisation?.orgHolidays?.map((h) =>
          dateFormatter(new Date(h.holidayStartDate))
        ) ?? [];

      let duration = 0;
      for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
        const day = d.getDay();
        const formattedDate = d.toISOString().split("T")[0];
        if (
          !excludedDays.includes(day) &&
          !holidays.includes(dateFormatter(new Date(formattedDate)))
        ) {
          duration++;
        }
      }
      return duration;
    },
    [user, nonWorkingDays]
  );

  /**
   * Calculates progress metrics for a single project using the component's duration logic.
   */
  const calculateProjectMetrics = useCallback(
    (project: Project) => {
      const { actualStartDate, actualEndDate, progressionPercentage } = project;

      if (!actualStartDate || !actualEndDate) {
        return { duration: 0, weightedProgress: 0, progress: 0 };
      }

      const duration = calculateDurations(
        new Date(actualStartDate),
        new Date(actualEndDate)
      );
      const progress = Math.round(Number(progressionPercentage || 0) * 100);
      const weightedProgress = progress * duration;

      return { duration, weightedProgress, progress };
    },
    [calculateDurations]
  );

  /**
   * Builds a complete project hierarchy including portfolios, orphan programs,
   * and standalone projects, with weighted progress calculated at each level.
   */
  const buildCompleteHierarchy = useCallback(
    (projectsList: Project[]): HierarchyItem[] => {
      const portfolioMap = new Map<string, Calculable<PortfolioNode>>();
      const orphanProgramMap = new Map<string, Calculable<ProgramNode>>();
      const standaloneProjects: ProjectNode[] = [];

      for (const project of projectsList) {
        if (!project.projectId) continue;

        const { duration, weightedProgress, progress } =
          calculateProjectMetrics(project);
        const projectNode: ProjectNode = {
          ...project,
          type: "project",
          progress,
        };

        const hasPortfolio = !!project.portfolio?.portfolioId;
        const hasProgram = !!project.program?.programId;

        if (hasPortfolio) {
          const portfolioId = project.portfolio!.portfolioId;
          if (!portfolioMap.has(portfolioId)) {
            portfolioMap.set(portfolioId, {
              type: "portfolio",
              portfolioId,
              portfolioName:
                project.portfolio!.portfolioName || "Unnamed Portfolio",
              progress: 0,
              projects: [],
              programs: [],
              __totalDuration: 0,
              __weightedProgress: 0,
            });
          }
          const portfolioEntry = portfolioMap.get(portfolioId)!;
          portfolioEntry.__totalDuration += duration;
          portfolioEntry.__weightedProgress += weightedProgress;

          if (hasProgram) {
            const programId = project.program!.programId;
            let programEntry = portfolioEntry.programs.find(
              (p) => p.programId === programId
            ) as Calculable<ProgramNode> | undefined;

            if (!programEntry) {
              programEntry = {
                type: "program",
                programId,
                programName: project.program!.programName || "Unnamed Program",
                progress: 0,
                projects: [],
                __totalDuration: 0,
                __weightedProgress: 0,
              };
              portfolioEntry.programs.push(programEntry as ProgramNode);
            }

            programEntry.__totalDuration += duration;
            programEntry.__weightedProgress += weightedProgress;
            programEntry.projects.push(projectNode);
          } else {
            portfolioEntry.projects.push(projectNode);
          }
        } else if (hasProgram) {
          const programId = project.program!.programId;
          if (!orphanProgramMap.has(programId)) {
            orphanProgramMap.set(programId, {
              type: "program",
              programId,
              programName: project.program!.programName || "Unnamed Program",
              progress: 0,
              projects: [],
              __totalDuration: 0,
              __weightedProgress: 0,
            });
          }
          const programEntry = orphanProgramMap.get(programId)!;
          programEntry.__totalDuration += duration;
          programEntry.__weightedProgress += weightedProgress;
          programEntry.projects.push(projectNode);
        } else {
          standaloneProjects.push(projectNode);
        }
      }

      const finalPortfolios = Array.from(portfolioMap.values())?.map((p) => {
        p.programs.forEach((prog) => {
          const program = prog as Calculable<ProgramNode>;
          program.progress =
            program.__totalDuration > 0
              ? Math.round(program.__weightedProgress / program.__totalDuration)
              : 0;
          delete (program as any).__totalDuration;
          delete (program as any).__weightedProgress;
        });
        p.progress =
          p.__totalDuration > 0
            ? Math.round(p.__weightedProgress / p.__totalDuration)
            : 0;
        delete (p as any).__totalDuration;
        delete (p as any).__weightedProgress;
        return p;
      });

      const finalOrphanPrograms = Array.from(orphanProgramMap.values())?.map(
        (p) => {
          p.progress =
            p.__totalDuration > 0
              ? Math.round(p.__weightedProgress / p.__totalDuration)
              : 0;
          delete (p as any).__totalDuration;
          delete (p as any).__weightedProgress;
          return p;
        }
      );

      return [
        ...finalPortfolios,
        ...finalOrphanPrograms,
        ...standaloneProjects,
      ];
    },
    [calculateProjectMetrics]
  );

  // 3. UPDATED useEffect TO USE THE NEW LOGIC
  const [spiPortfolioAndProgram, setSpiPortfolioAndProgram] =
    useState<Record<string, number>>();
  useEffect(() => {
    const newData = buildCompleteHierarchy(filterData ?? []);
    setSpiPortfolioAndProgram(
      calculatePortfolioAndProgramSPIs(filterData ?? [])
    );
    setHierarchyData(newData);
  }, [filterData, buildCompleteHierarchy]);

  const close = () => {
    setIsOpenPopUp(false);
    setEditData(undefined);
    setProjectId(undefined);
  };

  const handleView = (id: string) => {
    navigate("/project-details/" + id);
  };

  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const { validatePlan } = usePlanValidation();

  const handleOpenPopUp = () => {
    if (validatePlan("project").valid) {
      setIsPopUpOpen(!isPopUpOpen);
    }
  };

  const projectDuplicateMutation = useProjectDuplicateMutation();
  const createDuplicate = (id: string) => {
    if (!validatePlan("project").valid) {
      return;
    }
    projectDuplicateMutation.mutate(id, {
      onSuccess(data) {
        toast.success(data.data.message);
        projectQuery.refetch();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };
  const [showInput, setShowInput] = useState("");
  const [updateValue, setUpdateValue] = useState<{
    type: "portfolio" | "program";
    id: string;
    value: string;
  }>();

  const portfolioUpdateMutation = usePortfolioUpdateMutation();
  const programUpdateMutation = useProgramUpdateMutation();
  const updatePortfolioAndProgram = () => {
    if (updateValue && updateValue.type == "portfolio" && updateValue.value) {
      portfolioUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig
            );
          },
        }
      );
    } else if (
      updateValue &&
      updateValue.type == "program" &&
      updateValue.value
    ) {
      programUpdateMutation.mutate(
        { id: updateValue.id, value: updateValue.value },
        {
          onSuccess() {
            setUpdateValue(undefined);
            setShowInput("");
            projectQuery.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig
            );
          },
        }
      );
    } else {
      setUpdateValue(undefined);
      setShowInput("");
    }
  };
  const fullScreen = useRef<HTMLDivElement | null>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);

      const navbar = document.getElementById("navbar");
      const sidebar = document.getElementById("Sidebar");

      if (document.fullscreenElement) {
        if (navbar) navbar.classList.add("!hidden");
        if (sidebar) sidebar.classList.add("!hidden");
      } else {
        if (navbar) navbar.classList.remove("!hidden");
        if (sidebar) sidebar.classList.remove("!hidden");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    if (document.fullscreenElement) {
      handleFullscreenChange();
    }
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };
  const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
    portfolio: string;
    program: string;
  }>();

  // 4. COLUMN DEFINITION UPDATED TO HANDLE NEW DATA STRUCTURE
  const columnDef: ColumeDef[] = [
    {
      key: "projectName",
      header: t("project_name"),
      sorting: true,
      colspan: (data: any) => {
        return data.type !== "project" ? 7 : 1;
      },
      onCellRender: (item: HierarchyItem) => {
        let spiColor = "#68B266"; // Default green color
        if (item.type === "project" && typeof item.spi === "number") {
          if (item.spi < 80) spiColor = "#EA4335"; // Red
          else if (item.spi >= 80 && item.spi < 95) spiColor = "#FFA500"; // Orange
        } else if (item.type == "portfolio") {
          const spi = spiPortfolioAndProgram
            ? spiPortfolioAndProgram[item.portfolioId]
            : 0;
          if (spi < 80) spiColor = "#EA4335"; // Red
          else if (spi >= 80 && spi < 95) spiColor = "#FFA500"; // Orange
          // Default color for non-project items
        } else if (item.type == "program") {
          const spi = spiPortfolioAndProgram
            ? spiPortfolioAndProgram[item.programId]
            : 0;
          if (spi < 80) spiColor = "#EA4335"; // Red
          else if (spi >= 80 && spi < 95) spiColor = "#FFA500"; // Orange
        }
        return (
          <div className="w-full flex items-center justify-between gap-2">
            {item.type === "project" && (
              <div className="text-left  !max-w-32 truncate">
                {item.isActive ? (
                  <TooltipProvider delayDuration={0}>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Link
                          className="text-primary-500 underline "
                          to={
                            user?.subscription?.planType ==
                              PlanTypeEnumSchema.FREE || !user?.subscription
                              ? `/tasks/${item.projectId}`
                              : `/projectDashboard/${item.projectId}`
                          }
                        >
                          {item.projectName}
                        </Link>
                      </TooltipTrigger>
                      <TooltipContent>{item.projectName}</TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                ) : (
                  <TooltipProvider delayDuration={0}>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <div className={`truncate w-32 `}>
                          {item.projectName}
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>{item.projectName}</TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
            )}

            {item.type === "program" ? (
              <div className=" max-w-[20rem]">
                {showInput == item.programId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.programName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "program",
                          id: item.programId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={() => {
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-sm text-red-400 cursor-pointer `}
                      onClick={() => {
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      ✖
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center truncate ">
                      {item.programName}
                    </div>
                    {user?.userOrganisation[0].role &&
                      user?.userOrganisation[0].role ==
                        UserRoleEnumValue.ADMINISTRATOR && (
                        <>
                          <img
                            src={NewEditIcon}
                            className=" h-4 w-4 cursor-pointer"
                            onClick={() => setShowInput(item.programId)}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4 w-4 cursor-pointer"
                            onClick={() => {
                              setDeletePortfolioAndProgram({
                                portfolio: "",
                                program: item.programId,
                              });
                            }}
                          />
                        </>
                      )}
                  </div>
                )}
              </div>
            ) : item.type === "portfolio" ? (
              <div className=" max-w-[26rem]">
                {showInput == item.portfolioId ? (
                  <div className="flex gap-2 items-center">
                    <InputText
                      className="mt-0 my-2 h-[40px]"
                      defaultValue={item.portfolioName ?? ""}
                      onKeyDown={(e) =>
                        e.key == "Enter" ? updatePortfolioAndProgram() : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        setUpdateValue({
                          type: "portfolio",
                          id: item.portfolioId,
                          value: val,
                        });
                      }}
                    />
                    <span
                      className={` cursor-pointer `}
                      onClick={() => {
                        updatePortfolioAndProgram();
                      }}
                    >
                      <img src={CheckedSvg} className="w-5 max-w-5" />
                    </span>
                    <span
                      className={`font-bold text-xs text-red-400 cursor-pointer `}
                      onClick={() => {
                        setUpdateValue(undefined);
                        setShowInput("");
                      }}
                    >
                      ✖
                    </span>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <div className="h-14 flex items-center !truncate ">
                      {item.portfolioName}
                    </div>
                    {user?.userOrganisation[0].role &&
                      user?.userOrganisation[0].role ==
                        UserRoleEnumValue.ADMINISTRATOR && (
                        <>
                          <img
                            src={NewEditIcon}
                            className="h-4 w-4 cursor-pointer"
                            onClick={() => setShowInput(item.portfolioId)}
                          />
                          <img
                            src={TrashCan}
                            className="mr-2 h-4 w-4 cursor-pointer"
                            onClick={() => {
                              setDeletePortfolioAndProgram({
                                portfolio: item.portfolioId,
                                program: "",
                              });
                            }}
                          />{" "}
                        </>
                      )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            <div
              className={`flex items-center gap-2 ${
                item.type === "program" ? "mr-9" : "mr-6"
              }`}
            >
              {item.type !== "project" && (
                <PercentageCircle
                  percentage={item.progress} // Use the calculated progress for all types
                  roundColor={spiColor}
                />
              )}
            </div>
          </div>
        );
      },
    },
    {
      key: "createdByUser",
      header: t("Project Manager"),
      onCellRender: (item: HierarchyItem) => {
        if (item.type == "project") {
          const userPm = item.assignedUsers?.find((u) => {
            return u?.projectRole == UserRoleEnumValue.PROJECT_MANAGER;
          });
          return userPm ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="ml-3 flex">
                    <div>
                      <UserAvatar
                        className="shadow-sm shadow-gray-300 border-2 border-white"
                        user={userPm?.user}
                      />
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-sm">
                    {userPm?.user.firstName && userPm?.user.lastName
                      ? `${userPm?.user.firstName} ${userPm?.user.lastName}`
                      : userPm?.user.email}
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            <></>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      key: "status",
      header: t("status"),
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            <div
              className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
                item.status
              )} rounded justify-center items-center gap-px inline-flex`}
            >
              <div className=" text-xs font-medium leading-tight">
                {item.status
                  .toLowerCase()
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())}
              </div>
            </div>
          </>
        ) : (
          <></>
        ),
    },
    {
      key: "startDate",
      header: t("start_date"),
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>{dateFormatter(new Date(item.startDate))}</>
        ) : (
          <></>
        ),
    },
    {
      key: "actualEndDate",
      header: t("actual_date"),
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.actualEndDate
              ? dateFormatter(new Date(item.actualEndDate))
              : "N/A"}
          </>
        ) : (
          <></>
        ),
    },
    {
      key: "estimatedEndDate",
      header: t("estimated_end_date"),
      sorting: true,
      onCellRender: (item: HierarchyItem) =>
        item.type === "project" ? (
          <>
            {item.estimatedEndDate
              ? dateFormatter(new Date(item.estimatedEndDate))
              : "N/A"}
          </>
        ) : (
          <></>
        ),
    },
    {
      key: "progressionPercentage",
      header: t("progress"),
      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        // This cell now renders progress for all hierarchy item types
        let spiColor = "#68B266"; // Default green color
        if (item.type === "project" && item?.tasks?.length > 0) {
          if (item.type === "project" && typeof item.spi === "number") {
            if (typeof item.spi === "number") {
              const uniqueFlags = new Set(item.tasks?.map((t) => t.flag));

              if (uniqueFlags.size === 1) {
                const onlyFlag = uniqueFlags.values().next().value;
                const flagColorMap: Record<string, string> = {
                  Green: "#68B266",
                  Red: "#EA4335",
                  Orange: "#FFA500", // Or "Orange" if that's the correct flag
                };

                spiColor = flagColorMap[onlyFlag as string] ?? "#68B266"; // Default to green if flag is unrecognized
              } else {
                const spi = item.spi;

                spiColor =
                  spi < 80
                    ? "#EA4335" // Red
                    : spi < 95
                    ? "#FFA500" // Orange
                    : "#68B266"; // Green
              }
            }
          } else {
            spiColor =
              Number((item as any)?.progress) < 25
                ? "#EA4335"
                : Number((item as any)?.progress) >= 25 &&
                  Number((item as any)?.progress) < 50
                ? "#FFA500"
                : Number((item as any)?.progress) >= 50 &&
                  Number((item as any)?.progress) < 75
                ? "#4169E1"
                : Number((item as any)?.progress) >= 75 &&
                  Number((item as any)?.progress) <= 100
                ? "#68B266"
                : "#EA4335";
            // Default color for non-project items
          }
        } else {
          if (item.type == "project" && typeof item?.spi === "number") {
            const todayDate = new Date();
            const projectStartDate = new Date(item.startDate ?? "");
            if (projectStartDate < todayDate) {
              spiColor = "#EA4335";
            }
          }
        }

        return (
          <div>
            {item.type == "project" && (
              <PercentageCircle
                percentage={item.progress} // Use the calculated progress for all types
                roundColor={spiColor}
              />
            )}
          </div>
        );
      },
    },
    {
      key: "estimatedBudget",
      header: t("budget"),
      sorting: true,
      onCellRender: (item: HierarchyItem) => {
        return item.type === "project" &&
          item.estimatedBudget &&
          item.estimatedBudget !== "undefined" ? (
          <>{item.estimatedBudget ?? 0}</>
        ) : (
          <></>
        );
      },
    },
    {
      key: "Action",
      header: t("actions"),
      onCellRender: (item: HierarchyItem) => {
        if (item.type !== "project") return <></>; // Actions only for projects

        const findUser = item?.assignedUsers?.find(
          (t: { user: { userId: string | undefined } }) =>
            t.user.userId == user?.userId
        );

        return (
          <>
            <DropdownMenu>
              <DropdownMenuTrigger
                asChild
                disabled={
                  !item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR)
                }
                className={`${
                  !item.isActive ||
                  (findUser &&
                    findUser.projectRole == UserRoleEnumValue.COLLABORATOR)
                    ? "opacity-65"
                    : ""
                }`}
              >
                <div
                  className={`cursor-pointer  px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex ${
                    !item.isActive ? "cursor-not-allowed" : ""
                  }`}
                >
                  <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-fit flex flex-col gap-1">
                <DropdownMenuSeparator className="mx-1" />
                <DropdownMenuItem onClick={() => handleView(item.projectId)}>
                  <Settings className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_settings")}
                  </span>
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setProjectId(item.projectId)}>
                  <ScrollText className="mr-2 h-4 w-4 text-[#44546F]" />
                  <span className="p-0 font-normal h-auto">
                    {t("create_task")}
                  </span>
                </DropdownMenuItem>
                {user?.userOrganisation[0]?.role ==
                  UserRoleEnumValue.ADMINISTRATOR && (
                  <DropdownMenuItem
                    onClick={() => createDuplicate(item.projectId)}
                  >
                    <img src={DuplicateIcon} className="h-4 w-4 mr-2" />
                    <span className="p-0 font-normal h-auto">
                      {t("duplicate_project")}
                    </span>
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem
                  onClick={() => navigate("/members/" + item.projectId)}
                >
                  <img src={Users} className="h-4 w-4 mr-2" />
                  <span className="p-0 font-normal h-auto">
                    {t("project_members")}
                  </span>
                </DropdownMenuItem>
                {user?.userOrganisation[0]?.role ==
                  UserRoleEnumValue.ADMINISTRATOR && (
                  <DropdownMenuItem onClick={() => setRemove(item.projectId)}>
                    <img src={TrashCan} className="h-4 w-4 mr-2" />
                    <span className="p-0 font-normal h-auto text-red-500">
                      {t("remove_project")}
                    </span>
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        );
      },
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case ProjectStatusEnumValue.NOT_STARTED:
        return "!bg-status-gray text-white";
      case ProjectStatusEnumValue.ON_HOLD:
        return "!bg-status-purple text-white";
      case ProjectStatusEnumValue.ACTIVE:
        return "!bg-status-green text-white";
      case ProjectStatusEnumValue.CLOSED:
        return "!bg-status-black text-white";
    }
  };

  const removeProject = () => {
    removeProjectMutation.mutate(remove ?? "", {
      onSuccess(data) {
        toast.success(data.data.message);
        projectQuery.refetch();
        setRemove(undefined);
      },
      onError(error) {
        toast.error(errorKeyFormate(error.response?.data.message + ""));
      },
    });
  };

  const removeProgramMutation = useRemoveProgramMutation();
  const removePortfolioMutation = useRemovePortfolioMutation();
  const handleRemovePortfolioAndProgram = () => {
    if (deletePortfolioAndProgram?.portfolio) {
      removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
        onSuccess() {
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
    if (deletePortfolioAndProgram?.program) {
      removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
        onSuccess() {
          projectQuery.refetch().then(() => {
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
  };
  const innerTable = (data: any, level = 0) => {
    return (
      <div className={`w-full`}>
        <Table
          expandAll={Boolean(searchParams.size) || isExpand}
          key="Project view"
          hideHeaders={true}
          columnDef={
            columnDef?.map((d, i) => {
              return {
                ...d,
                className: () => {
                  if (level == 0) {
                    return `${
                      i == columnDef.length - 3 ? "rounded-e-xl" : ""
                    } !p-0`;
                  }
                  return "";
                },
              };
            }) ?? []
          }
          className="border-0 !px-0 !rounded-none [&>*]:!overflow-x-hidden "
          data={[
            ...(Array.isArray(data.programs) ? data.programs : []),
            ...(Array.isArray(data.projects) ? data.projects : []),
          ]}
          onAccordionRender={(data) =>
            [
              ...(Array.isArray(data.programs) ? data.programs : []),
              ...(Array.isArray(data.projects) ? data.projects : []),
            ].length > 0 ? (
              innerTable(data, level + 1)
            ) : (
              <></>
            )
          }
          onRowClassName={(data) => {
            return `${
              data.type === "project" && !data.isActive
                ? "opacity-70 cursor-not-allowed ml-2  "
                : "ml-2"
            } ${
              data.type === "portfolio"
                ? "!bg-primary-500/30 !border-none "
                : ""
            }  border-b  ${
              data.type === "program" ? "!bg-gray-450/30 !border-none " : ""
            }`;
          }}
          showDropDown={(data) => {
            return `${
              data.type === "project" ? "opacity-0 !pl-0" : ""
            } !pl-0 !rounded-s-xl`;
          }}
          showDropDownImg={() => {
            return "!block";
          }}
          hidePagination={true}
          notShowNoDataFound={true}
        />
      </div>
    );
  };
  const [isOpenWorkLoad, setIsOpenWorkLoad] = useState(false);
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      (data ?? [])?.map((t) => {
        return {
          Name: t.projectName,
          "Start Date": dateFormater(new Date(t.startDate)),
          ...(t?.actualEndDate && {
            "Estimated End Date": t.estimatedEndDate
              ? dateFormater(new Date(t.estimatedEndDate))
              : "",
            "Actual End Date": t.actualEndDate
              ? dateFormater(new Date(t.actualEndDate))
              : "",
            "Re-CalculateEndDate": t.reCalculateEndDate
              ? dateFormater(new Date(t.reCalculateEndDate))
              : "",
          }),
        };
      })
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `portfolio.xlsx`);
  };
  const [isExpand, setIsExpand] = useState(Boolean(searchParams.size) ?? true);
  const [filterUnit, setFilterUnit] = useState(1);
  const [selectedDateType, setSelectedDateType] = useState<
    "estimated" | "actual"
  >("estimated");
  const [compare, setCompare] = useState<
    "estimatedToActual" | "actualToReCalculated" | "all" | ""
  >("");
  const options = [
    {
      label: t("Estimated Dates"),
      value: "estimated",
      tooltip: t("Estimated dates tooltip"),
    },
    {
      label: t("Current Dates"),
      value: "actual",
      tooltip: t("Current dates tooltip"),
    },
  ];
  const [isShowVideo, setIsShowVideo] = useState(false);

  // Remaining JSX of your component is here...
  // ... No changes needed for the rest of the file
  const navigtae = useNavigate();
  const toggleWorkload = () => {
    if (
      !user?.subscription ||
      !user?.subscription?.planType ||
      user?.subscription?.planType == PlanTypeEnumSchema.FREE
    ) {
      navigtae("/plans");
    } else {
      setIsOpenWorkLoad(!isOpenWorkLoad);
    }
  };
  const projectFilter =  useMemo(() => <ProjectFilter
                    project={data}
                    fieldToShow={[
                      FIELDS.STATUS,
                      FIELDS.DELAY,
                      FIELDS.DATE,
                      FIELDS.BUDGET,
                    ]} // adjust as needed
                    filteredData={(data) => setFilterData(data || [])}
                    appleed={(applied) => {
                      console.log(applied);
                      if(filterData){
                        setLoader(false)
                      }

                    }}
                  />, [data])
  return (
    <div className="w-full h-full relative" ref={fullScreen}>
      {(loader || projectQuery.isRefetching) && (
        <Loader className="absolute top-0 left-0 z-50 w-full h-full bg-white" />
      )}{" "}
      <>
        {data && data.length >0 && (
          <div className="h-full  p-4 pb-0  w-full flex flex-col gap-2">
            {
              <div className="w-full flex justify-between items-center px-6">
                <div className="flex gap-2 items-end">
                  {projectFilter}
                  <Button
                    variant={"primary"}
                    className="w-fit flex gap-1 ml-full mr-12"
                    size={"sm"}
                    onClick={handleOpenPopUp}
                    disabled={
                      user?.userOrganisation[0]?.role !==
                      UserRoleEnumValue.ADMINISTRATOR
                    }
                  >
                    <img
                      src={Plus}
                      className="w-3 min-w-3 brightness-0 invert "
                    />
                    {t("add_project")}
                  </Button>
                </div>
                <div className="flex justify-between pl-4 mt-2 items-center ">
                  <ul className="flex items-center gap-3 text-sm font-medium">
                    {view == ProjectDefaultViewEnumValue.GANTT && (
                      <Button
                        variant={"link"}
                        onClick={() => setIsShowVideo(true)}
                        className="text-primary-500 underline underline-offset-2 text-sm ml-auto h-fit !p-0  "
                      >
                        {t("Check the video")}
                      </Button>
                    )}
                    <div className="text-[#787486] text-[16px]">
                      {t("Views")}
                    </div>
                    {viewOption?.map((item) => {
                      return (
                        <TooltipProvider key={item.value}>
                          <Tooltip delayDuration={0}>
                            <TooltipTrigger asChild>
                              <li className="flex-1">
                                <button
                                  className={`text-gra relative flex items-center justify-center px-2 py-[0.4rem] h-fit gap-2 rounded-xl  shadow-lg hover:text-gray-700 ${
                                    item.value == view
                                      ? "bg-primary-500"
                                      : "bg-gray-50"
                                  }`}
                                  onClick={() => {
                                    setView(item.value);
                                  }}
                                >
                                  <img
                                    src={item.icon}
                                    className="w-6 min-w-6"
                                    style={{
                                      filter:
                                        item.value == view
                                          ? "brightness(100000%)"
                                          : "none",
                                    }}
                                  />
                                </button>
                              </li>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm">
                                {t("View")}{" "}
                                {t(
                                  item.value ==
                                    ProjectDefaultViewEnumValue.GANTT
                                    ? "rode_map"
                                    : item.value.toLowerCase()
                                )}
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      );
                    })}
                  </ul>
                </div>
              </div>
            }
            <div className="flex items-center justify-between">
              <div className="flex gap-2 items-center justify-start mr-2">
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="list-none">
                        <Button
                          variant={"none"}
                          onClick={() => setIsExpand(!isExpand)}
                          className=" "
                          size={"sm"}
                        >
                          <img
                            src={!isExpand ? Collaps : Expand}
                            alt=""
                            className="w-5 min-w-5"
                          />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">
                        {t(!isExpand ? "expand" : "collapse")}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
                {view == ProjectDefaultViewEnumValue.GANTT && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="list-none">
                          <Button
                            variant={"none"}
                            className="select-none"
                            disabled={filterUnit == 0}
                            onClick={() => setFilterUnit((prev) => prev - 1)}
                          >
                            <img src={ZoomIn} className="w-4 min-w-4" />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("zoomin")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
                {view == ProjectDefaultViewEnumValue.GANTT && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <li className="list-none">
                          <Button
                            variant={"none"}
                            className="select-none"
                            disabled={filterUnit == 4}
                            onClick={() => setFilterUnit((prev) => prev + 1)}
                          >
                            <img src={ZoomOut} className="w-4 min-w-4" />
                          </Button>
                        </li>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p className="text-sm">{t("zoomout")}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <li className="list-none">
                        <Button
                          variant={"none"}
                          className="select-none"
                          onClick={() => enterFullscreen()}
                        >
                          <img
                            src={!isFullscreen ? FullScreen : ExitFullscreen}
                            className={`${
                              !isFullscreen ? "w-5 min-w-5" : "w-3.5 min-w-3.5"
                            }`}
                          />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">
                        {t(!isFullscreen ? "full_Screen" : "full_exit_screen")}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
                <TooltipProvider>
                  <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                      <li className="list-none">
                        <Button
                          variant={"none"}
                          className="select-none"
                          onClick={() => projectQuery.refetch()}
                        >
                          <img src={Refresh} className={`w-3.5 min-w-3.5`} />
                        </Button>
                      </li>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white rounded-md px-2 py-1.5 shadow-lg border border-gray-450/30">
                      <p className="text-sm">{t("reload")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
                <div>
                  <Button
                    variant={"none"}
                    className=" !p-2"
                    onClick={() => downloadExcel()}
                  >
                    <img src={ExcelIcon} className="w-4 min-w-4" />
                  </Button>
                </div>
                {view == ProjectDefaultViewEnumValue.GANTT && (
                  <Button
                    variant={isOpenWorkLoad ? "primary" : "primary_outline"}
                    onClick={() => toggleWorkload()}
                    className="h-fit text-xs py-1 hidden"
                    size={"sm"}
                  >
                    {t("Work load")}
                  </Button>
                )}
              </div>
              {view == ProjectDefaultViewEnumValue.GANTT && (
                <div className="flex gap-2">
                  <div className=" flex gap-2 items-center  border border-gray-200 rounded-md px-2">
                    <div className="flex gap-4">
                      {options?.map((option) => (
                        <label
                          key={option.value}
                          className="flex items-center space-x-2 relative"
                        >
                          <input
                            type="radio"
                            name="dateType"
                            value={option.value}
                            checked={selectedDateType === option.value}
                            onChange={() => {
                              setSelectedDateType(
                                option.value as "estimated" | "actual"
                              );
                              setCompare("");
                            }}
                            className="form-radio text-blue-600"
                          />
                          <span>{option.label}</span>
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 items-center absolute -top-2.5 -right-2">
                                <img
                                  src={InfoCircle}
                                  className="h-[14px] w-[14px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm text-center w-96">
                                  {option.tooltip}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </label>
                      ))}
                    </div>
                  </div>
                  <Select
                    key={compare}
                    className="p-0 w-80"
                    options={[
                      {
                        label: t("Compare schedules"),
                        value: "",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between">
                            {" "}
                            {t("Estimated VS Actual schedule")}{" "}
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger className="flex gap-1 items-center">
                                  <img
                                    src={InfoCircle}
                                    className="h-[14px] w-[14px] brightness-0"
                                    alt="InfoCircle"
                                  />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm text-center w-96">
                                    {t("Current dates tooltip")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "estimatedToActual",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between">
                            {" "}
                            {t("Actual VS Recalculated schedule")}{" "}
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger className="flex gap-1 items-center">
                                  <img
                                    src={InfoCircle}
                                    className="h-[14px] w-[14px] brightness-0"
                                    alt="InfoCircle"
                                  />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm text-center w-96">
                                    {t("Recalculated schedule tooltip")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "actualToReCalculated",
                      },
                      {
                        label: t("Compare All"),
                        value: "all",
                      },
                    ]}
                    defaultValue={[
                      {
                        label: t("Compare schedules"),
                        value: "",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between">
                            {" "}
                            {t("Estimated VS Actual schedule")}{" "}
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger className="flex gap-1 items-center">
                                  <img
                                    src={InfoCircle}
                                    className="h-[14px] w-[14px] brightness-0"
                                    alt="InfoCircle"
                                  />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm text-center !w-96 text-wrap">
                                    {t("Current dates tooltip")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "estimatedToActual",
                      },
                      {
                        label: (
                          <div className="flex w-full items-center justify-between">
                            {" "}
                            {t("Actual VS Recalculated schedule")}{" "}
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger className="flex gap-1 items-center">
                                  <img
                                    src={InfoCircle}
                                    className="h-[14px] w-[14px] brightness-0"
                                    alt="InfoCircle"
                                  />
                                </TooltipTrigger>
                                <TooltipContent>
                                  <p className="text-sm text-center !w-96 text-wrap">
                                    {t("Recalculated schedule tooltip")}
                                  </p>
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          </div>
                        ),
                        value: "actualToReCalculated",
                      },
                      {
                        label: t("Compare All"),
                        value: "all",
                      },
                    ].find((t) => t.value == compare)}
                    onChange={(e: any) => {
                      const val = e as Options;
                      if (val && val.value) {
                        setCompare(
                          val.value as
                            | "estimatedToActual"
                            | "actualToReCalculated"
                            | "all"
                        );
                        setSelectedDateType("estimated");
                      } else {
                        setCompare("");
                      }
                      if (val.value == "actualToReCalculated") {
                        setSelectedDateType("actual");
                      }
                    }}
                    placeholder={t("Compare schedules")}
                    styles={reactSelectStyle}
                  />
                </div>
              )}
            </div>
            {view == ProjectDefaultViewEnumValue.LIST && (
              <div className="h-[80%]">
                {filterData && (
                  <Table
                    tableClassName=" border-spacing-y-1 border-separate"
                    key={hierarchyData.length}
                    expandAll={isExpand}
                    columnDef={
                      columnDef?.map((d, i) => {
                        return {
                          ...d,
                          className: () => {
                            return `${
                              i == columnDef.length - 3 ? "rounded-e-xl" : ""
                            } !p-0`;
                          },
                        };
                      }) ?? []
                    }
                    data={hierarchyData}
                    className="overflow-auto "
                    onAccordionRender={(data) => innerTable(data)}
                    onRowClassName={(data) => {
                      return `${
                        data.type === "project" && !data.isActive
                          ? "opacity-70 cursor-not-allowed ml-2 !border-b "
                          : "ml-2"
                      } ${
                        data.type === "portfolio" ? "!bg-primary-500/30" : ""
                      } ${data.type === "program" ? "!bg-gray-450/30" : ""}`;
                    }}
                    showDropDown={(data) => {
                      return `${
                        data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                      } !rounded-s-xl`;
                    }}
                    showDropDownArrow={(data) => {
                      return `${
                        data.type === "project" ? "opacity-0 !pl-0 " : "!pl-0"
                      }`;
                    }}
                    notShowNoDataFound={true}
                  />
                )}
                {!data && (
                  <div className="flex justify-center p-3 w-full">
                    {t("no_projects_available")}
                  </div>
                )}
              </div>
            )}
            {view &&
              view == ProjectDefaultViewEnumValue.GANTT &&
              (!projectQuery.isRefetching || projectQuery.isFetched) &&
              filterData &&
              filterData?.length > 0 && (
                <GanttView
                  key={projectQuery.status}
                  projects={filterData ?? []}
                  setFilterUnit={setFilterUnit}
                  FilterUnit={filterUnit}
                  expandAll={isExpand}
                  selectedDateType={selectedDateType}
                  compare={compare}
                  setSelectedDateType={setSelectedDateType}
                  hierarchyData={hierarchyData}
                  isOpenWorkLoad={isOpenWorkLoad}
                />
              )}
            {filterData && filterData.length == 0 && data && data.length > 0 && <NoFilterProject />}
          </div>
        )}

        {projectQuery.isFetched && data && data.length == 0 && <NoProject />}

        {isOpenPopUp && (
          <CreateUpdateProjectForm
            handleClosePopUp={close}
            editData={editData}
            key={projectId}
          />
        )}
        {projectId && (
          <TaskSubTaskForm
            taskId={undefined}
            projectId={projectId}
            close={close}
          />
        )}
      </>
      {isPopUpOpen && <CreateProjectForm handleClosePopUp={handleOpenPopUp} />}
      <Dialog
        isOpen={Boolean(remove)}
        onClose={() => setRemove(undefined)}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeProjectMutation.isPending}
              disabled={removeProjectMutation.isPending}
              onClick={() => setRemove(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              className="text-white"
              onClick={removeProject}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(
          deletePortfolioAndProgram?.portfolio ||
            deletePortfolioAndProgram?.program
        )}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 text-center ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {deletePortfolioAndProgram?.portfolio
            ? t("remove_portfolio")
            : t("remove_program")}
          <span className="text-xs text-gray-600">
            (
            {t("remove_portfolio_and_project_description", {
              project: deletePortfolioAndProgram?.portfolio
                ? `${t("program")} ${t("and")} ${t("project")}`
                : `${t("project")}`,
            })}
            )
          </span>
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => setDeletePortfolioAndProgram(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              // isLoading={removeTaskMutation.isPending}
              // disabled={removeTaskMutation.isPending}
              onClick={handleRemovePortfolioAndProgram}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => {}}
          modalClass="rounded-lg h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div
            className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30"
            onClick={() => setIsShowVideo(false)}
          >
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/1083552233?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default ProjectsList;
